import { getPlanInfo } from '@mm/state/helpers/billing-info-helpers';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';

export const getUtilizationWarningText = (
  facebookPage: EnhancedBillingPage,
  utilizationPercentage: number,
  november2021Pricing: boolean,
  isAutomationsEnabled: boolean,
) => {
  const isFreeTrialPromotionWithoutSubscription =
    !!facebookPage?.redemption?.freeTrial && !facebookPage?.subscription;

  const planInfo = getPlanInfo(facebookPage);

  const period =
    facebookPage?.subscription?.billingPeriodLength === 'monthly'
      ? 'monthly'
      : 'yearly';

  if (facebookPage.twilioDailyLocked && !facebookPage.twilioCampaignCreated) {
    return `
        Unregistered SMS campaigns can use up to 3K message segments per day. 
        Your page is already used its daily limit and SMS channel is paused.
        Contact support at support@mobilemonkey.com to registered your campaign and increase limits
    `;
  }

  if (planInfo.isFreePlan || isFreeTrialPromotionWithoutSubscription) {
    return getFreeUtilizationWarningText(
      utilizationPercentage,
      november2021Pricing,
      isAutomationsEnabled,
    );
  }

  if (planInfo.isAnyProPlan) {
    if (utilizationPercentage > 99) {
      if (isAutomationsEnabled) {
        return {
          row1: 'Automations will shut down soon!',
          row2: 'Upgrade your plan to continue sending messages',
          row3: `This page has exceeded the ${period} send credits limit.`,
        };
      }
      return `
        This page has exceeded the ${period} send credits limit. Bots have been shut down!
        Click the button below to purchase more send credits to continue sending messages.
      `;
    }

    if (isAutomationsEnabled) {
      return {
        row1: 'Automations will shut down soon!',
        row2: ' Upgrade your plan to continue sending messages ',
        row3: `This page has reached ${utilizationPercentage}% of the ${period} send credits limit.`,
      };
    }

    return `
      This page has reached ${utilizationPercentage}% of the ${period} send credits limit.
      Bots will shut down soon! Click the button below to purchase more send credits to continue sending messages.
    `;
  }

  if (planInfo.isCustomTeam || planInfo.isLegacyTeamPlan) {
    return `
    SMS send credits reached its limit. Page cannot continue sending text messages. Please click the button below to purchase more SMS send credits
      `;
  }

  if (planInfo.isAnyTeamPlan) {
    if (utilizationPercentage > 99) {
      if (isAutomationsEnabled) {
        return {
          row1: 'Automations will shut down soon!',
          row2: 'Upgrade your plan to continue sending messages',
          row3: `Your subscription has exceeded the ${period} send credits limit.`,
        };
      }
      return `
        Your Agency subscription has exceeded the ${period} send credits limit.
        Bots have been shut down! Click the button below to purchase more send credits to continue sending messages.
      `;
    }

    if (isAutomationsEnabled) {
      return {
        row1: 'Automations will shut down soon!',
        row2: ' Upgrade your plan to continue sending messages ',
        row3: `Your subscription has reached ${utilizationPercentage}% of the ${period} send credits limit.`,
      };
    }

    return `
      Your Agency subscription has reached ${utilizationPercentage}% of the ${period} send credits limit.
      Bots will shut down soon! Click the button below to purchase more send credits to continue sending messages.
    `;
  }
  return '';
};

const getFreeUtilizationWarningText = (
  utilizationPercentage: number,
  november2021Pricing: boolean,
  isAutomationsEnabled: boolean,
) => {
  if (utilizationPercentage > 99) {
    if (isAutomationsEnabled) {
      return {
        row1: 'Automations will shut down soon!',
        row2: 'Upgrade your plan to continue sending messages',
        row3: `This page has exceeded the monthly send credits limit.`,
      };
    }

    return `
      This page has exceeded the monthly send credits limit. Bots will shut down!
      Upgrade to ${
        november2021Pricing ? 'STARTUP' : 'OPERATOR'
      } now to continue sending messages.
    `;
  }

  if (utilizationPercentage > 89) {
    if (isAutomationsEnabled) {
      return {
        row1: 'Automations will shut down soon!',
        row2: ' Upgrade your plan to continue sending messages ',
        row3: `This page has reached ${utilizationPercentage}% of the monthly send credits limit.`,
      };
    }

    return `
      This page has reached ${utilizationPercentage}% of the monthly send credits limit. Bots will shut down soon!
      Upgrade to ${
        november2021Pricing ? 'STARTUP' : 'OPERATOR'
      } now to increase your send credits limit.
    `;
  }

  if (isAutomationsEnabled) {
    return {
      row1: 'Automations will shut down soon!',
      row2: ' Upgrade your plan to continue sending messages ',
      row3: `This page has reached ${utilizationPercentage}% of the monthly send credits limit.`,
    };
  }

  return `
    This page has reached ${utilizationPercentage}% of the monthly send credits limit. Bots will shut down soon!
    Upgrade to ${
      november2021Pricing ? 'STARTUP' : 'OPERATOR'
    } now to increase your send credits limit.
  `;
};
